export default "__VITE_ASSET__6LF2gmiU__"